module.exports = __webpack_public_path__ + "files/f2761d5b6476b33c41677a3d47b01ba2.png";